import { pushNotification as pushNotificationLog } from '../resource/debug.js';

const log = pushNotificationLog.extend('log:fcm');

const FCM_DATABASE_NAME = 'firebase-messaging-database';
const FCM_OBJECT_STORE_NAME = 'firebase-messaging-store';

let messaging = undefined;

// avoid update service worker and setFcmToken action execute at the same time
let isGettingFcmToken = false;

/*
 * Can't use runtime env (resource/env.js) since need to be in sync with
 * resource/fcmServiceWorker.js
 *
 */
const projectId = process.env.PROJECT_ID;
const config = {
  apiKey: process.env.FCM_API_KEY,
  authDomain: `${projectId}.firebaseapp.com`,
  databaseURL: `https://${projectId}.firebaseio.com`,
  projectId: projectId,
  storageBucket: `${projectId}.appspot.com`,
  messagingSenderId: process.env.FCM_SENDER_ID,
  appId: process.env.FCM_APP_ID,
};

const initFcm = async () => {
  const [{ initializeApp }, { getMessaging }] = await Promise.all([
    import('firebase/app'),
    import('firebase/messaging'),
  ]);
  const app = initializeApp(config);
  messaging = getMessaging(app);
  log('iniFcm', { messaging });
};

const getFcmToken = async () => {
  if (!messaging || isGettingFcmToken) {
    log('getFcmToken early return', { messaging, isGettingFcmToken });
    return;
  }
  isGettingFcmToken = true;
  const { getToken } = await import('firebase/messaging');
  const options = {};

  if (!messaging.vapidKey) options.vapidKey = process.env.FCM_PUBLIC_VAPID_KEY;

  await navigator.serviceWorker.ready;
  const registration = await navigator.serviceWorker.getRegistration();
  log('getFcmToken get registration', { registration });

  if (registration && registration?.pushManager) {
    options.serviceWorkerRegistration = registration;

    log('getFcmToken getToken', { options });
    const token = await getToken(messaging, options);
    log('getFcmToken getToken done', { token });
    isGettingFcmToken = false;
    return token;
  }
};

const deleteFcmToken = async () => {
  if (!messaging) return;

  const { deleteToken } = await import('firebase/messaging');
  try {
    await deleteToken(messaging);
    log('deleteToken done');
  } catch (error) {
    log('deleteToken error', error);
    const { default: localforage } = await import('localforage');
    try {
      const store = await localforage.createInstance({
        name: FCM_DATABASE_NAME,
        storeName: FCM_OBJECT_STORE_NAME,
      });
      await store.clear();
      log('deleteToken clear store done');
    } catch (e) {
      log('deleteToken clear store error', e);
    }
  }
};

const getFcmMessaging = () => messaging;

export { initFcm, getFcmMessaging, getFcmToken, deleteFcmToken };
